import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setPostSupportUpdateStatus = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_UPDATE_STATUS_SUPPORT
            });
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostSupportUpdateStatus as SetPostSupportUpdateStatus
}